import {
    PageCollapsibleBlock,
    usePortalStore,
    EmptyResultsFiltersPlaceholder,
} from '@servicetitan/cp-ui';
import { observer } from 'mobx-react';
import { FC, SyntheticEvent } from 'react';
import { JobListItemWeb } from '../../../api/portal-dashboard.api';
import { JobsUrlMap } from './jobs-url-map';
import { ScheduledJobsListItem } from './scheduled-job-list-item';

interface DashboardJobsProps {
    loading: boolean;
    filtered: boolean;
    jobs?: JobListItemWeb[];
    resetFilters(): void;
}

export const DashboardJobs: FC<DashboardJobsProps> = observer(props => {
    const { filtered, jobs, loading, resetFilters } = props;
    const allJobsHref = JobsUrlMap.list;
    const { event } = usePortalStore();

    const onViewAllJobsClick = (e: SyntheticEvent<HTMLElement>) => {
        e.stopPropagation();
        e.preventDefault();
        event('redirect', ['jobs']);
    };

    let filteredJobs = jobs;
    if (filteredJobs?.length && filteredJobs.length > 3) {
        filteredJobs = filteredJobs.slice(0, 3);
    }

    return (
        <PageCollapsibleBlock
            icon="job"
            title="Upcoming Jobs"
            count={filteredJobs?.length ?? 0}
            allRecordsHref={allJobsHref}
            loading={loading}
            onAllRecordsClick={onViewAllJobsClick}
        >
            {!filteredJobs?.length && (
                <EmptyResultsFiltersPlaceholder
                    title="No upcoming jobs"
                    description="Upcoming jobs will show up here"
                    className="m-y-3"
                    showFilterButtons={filtered}
                    onClearFiltersClick={resetFilters}
                />
            )}
            {filteredJobs?.map(job => (
                <ScheduledJobsListItem key={job.id} job={job} />
            ))}
        </PageCollapsibleBlock>
    );
});
